import Image from 'next/legacy/image'
import {
  AnalysisComponentDetailMetrics,
  CAF_ANALYSIS_TYPE_MAP,
  COMPLEXITY_METRIC,
  ComplexityDetailItem,
} from '../../../../../model/caf.interface'
import useAppRouter from '../../../../../modules/hooks/common/useAppRouter'
import useIsMobile from '../../../../../modules/hooks/common/useIsMobile'
import useIsWebview from '../../../../../modules/hooks/common/useIsWebview'
import useWebviewNavigation from '../../../../../modules/hooks/webview/common/useWebviewNavigation'
import { n_caf } from '../../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { ICON_CHEVRON_RIGHT_GRAY } from '../../../../../modules/svg/svg'
import urls from '../../../../../modules/urls'
import { LESSON_ACTIVITIES_MAP, useLessonsStack } from '../../../../../pages/[lang]/webview/lessons'
import Accordion from '../../common/Accordion'

const ComplexityVocaAccordion = ({ data }: { data: AnalysisComponentDetailMetrics }) => {
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const isWebview = useIsWebview()
  const { useLessonsFlow } = useLessonsStack()
  const { push } = useLessonsFlow()
  const router = useAppRouter()
  const { lessonId, tab, componentId, metricTag, metricIndex } = router.query
  const { navigate } = useWebviewNavigation()
  const goToDetailPage = (metricId, title, level_tag) => () => {
    if (isWebview) {
      push(LESSON_ACTIVITIES_MAP.AIComplexityMetricDetailActivity, {
        metricId,
        error_tag: level_tag,
      })
    } else if (isMobile) {
      navigate({
        url: urls.webview.caf.analysis.detail(CAF_ANALYSIS_TYPE_MAP[1], metricId, level_tag),
      })
    } else {
      router.push(
        urls.student.newPortal.lessons.reviewDetail.asCafComplexityMetricDetail(
          lessonId,
          componentId,
          metricTag,
          metricId,
          level_tag,
          title
        )
      )
    }
  }

  const AccordionTitle = ({ detail }) => {
    return (
      <div className={`row-auto flex justify-between pr-[4px]`}>
        <span className={`text-[14px] font-medium text-black`}>
          {t(n_caf.complexity['vocab_' + detail.level_type])}
        </span>
        <span className="text-[14px] font-medium text-gray-500">{detail.ratio}%</span>
      </div>
    )
  }
  if (isMobile) {
    return (
      <>
        {data?.details?.map((detail: ComplexityDetailItem, idx) => (
          <Accordion key={idx} title={<AccordionTitle detail={detail} />} idx={idx + 1} className={'mb-[8px]'}>
            <span className="text-12 text-gray-500">ⓘ {t(n_caf.complexity.vocab_info)}</span>
            <div className="mt-16 flex flex-wrap">
              {Object.keys(detail.words)
                .slice(0, 15)
                .map((item) => (
                  <div
                    key={item}
                    className="border-1 mr-8 mb-8 items-center justify-center rounded-[50px] bg-gray-50 px-8 py-4"
                  >
                    <span className="text-14 text-gray-700">{item}</span>
                  </div>
                ))}
            </div>
            <div
              className="row-auto flex items-center justify-end"
              onClick={goToDetailPage(data.metric_id, COMPLEXITY_METRIC[detail.level_type], detail.level_tag)}
            >
              <span className="text-14 mr-9 font-medium text-gray-500">{t(n_caf.highlight.viewmore)}</span>
              <Image src={ICON_CHEVRON_RIGHT_GRAY} width={12} height={16} alt="arrow" />
            </div>
          </Accordion>
        ))}
      </>
    )
  } else {
    return (
      <>
        {data?.details?.map((detail: ComplexityDetailItem, idx) => (
          <Accordion
            key={idx}
            title={<AccordionTitle detail={detail} />}
            idx={idx + 1}
            className={'mb-[8px] cursor-pointer'}
          >
            <span className="text-12 cursor-default text-gray-500">ⓘ {t(n_caf.complexity.vocab_info)}</span>
            <div className="mt-16 flex cursor-default flex-wrap">
              {detail?.words &&
                Object.keys(detail.words)
                  ?.slice(0, 15)
                  ?.map((item) => (
                    <div
                      key={item}
                      className="border-1 mr-8 mb-8 items-center justify-center rounded-[50px] bg-gray-50 px-8 py-4"
                    >
                      <span className="text-14 text-gray-700">{item}</span>
                    </div>
                  ))}
            </div>
            <div
              className="row-auto flex cursor-pointer items-center justify-end"
              onClick={goToDetailPage(data.metric_id, COMPLEXITY_METRIC[detail.level_type], detail.level_tag)}
            >
              <span className="text-14 mr-9 font-medium text-gray-500">{t(n_caf.highlight.viewmore)}</span>
              <Image src={ICON_CHEVRON_RIGHT_GRAY} width={12} height={16} alt="arrow" />
            </div>
          </Accordion>
        ))}
      </>
    )
  }
}

export default ComplexityVocaAccordion
